export default __webpack_public_path__ + "static/media/illus_2FA_2.56b5f683.svg";